import notfound from '../../../Assets/images/il-empty.svg';
import React, {useEffect, useRef } from "react";
import { usePagination, useSortBy, useTable} from 'react-table';
import PaginationComponent from "../../../Components/PaginationTableServer/PaginationTableServer";

const InformadosTable = ({columns, data, fetchData, pageCount: controlledPageCount, currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy, setPagination, valoresFormularioEnvio }) => {
  const primerRenderizado = useRef(true);

  const {getTableProps, getTableBodyProps, headerGroups, prepareRow, page, pageCount, gotoPage, setSortBy, state: { pageIndex, pageSize, sortBy }} 
	= useTable(
		{
			columns
			, data
			, initialState: { pageIndex: currentpage, pageSize: controlledPageSize, sortBy: controlledSortBy }
			, manualPagination: true
			, pageCount: controlledPageCount
			, autoResetPage: false
			, autoResetSortBy: false
			, manualSortBy: true
		},
		useSortBy
		, usePagination
	)

  useEffect(() => {
        if (primerRenderizado.current) {
          primerRenderizado.current = false;
          return;
        }

        fetchData({ formulario: valoresFormularioEnvio, pageIndex, sortBy });
        setPagination(values => ({
          ...values,
          sortBy: sortBy
        }));
    }, [pageIndex, sortBy]);

  return (
    <div>
      <div className='accordion-body p-0 brd-top' style={{ overflow: "auto"}}>
        <table className="table table-sm" {...getTableProps()} style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              {headerGroups.map((headerGroup) => {
              const { key: hgKey, ...hgProps } = headerGroup.getHeaderGroupProps();
              return <tr key={hgKey} {...hgProps}>
                {headerGroup.headers.map((column) => {
                const { key, ...restProps } = column.getHeaderProps(
                  column.getSortByToggleProps(),
                  { className: column.className }
                );

                return data.length > 0 ? (
                  <th key={key} {...restProps}>
                  <span className="d-flex align-items-center gap-1">
                    {column.render("Header")}
                    <>
                    {column.isSorted ? (
                      column.isSortedDesc && data.length > 0 ? (
                      <i className="ico-chevron-down"></i>
                      ) : (
                      <i className="ico-chevron-up"></i>
                      )
                    ) : (
                      <>
                      <i className="ico-sort fs-7"></i>
                      </>
                    )}
                    </>
                  </span>
                  </th>
                ) : (
                  <th key={key} {...restProps}>
                  <span className="d-flex align-items-center gap-1">
                    {column.render("Header")}
                  </span>
                  </th>
                );
                })}
              </tr>
              })}
            </thead>
            <tbody {...getTableBodyProps()}>
            {
                page.length > 0 && page.map( (row) => {
                  prepareRow(row)
                  const { key: rowKey, ...rowProps } = row.getRowProps();
                  return (
                    <tr key={rowKey} {...rowProps}>
                      {row.cells.map((cell) => {
                        const { key: tdKey, ...tdProps } = cell.getCellProps({
                          className: cell.column.className
                        });
                        return <td key={tdKey} {...tdProps}>
                          {cell.render('Cell')}
                        </td>
                      })}
                    </tr>
                    )
                }) || <tr><td colSpan={headerGroups[0].headers.length + 1}>
                <div className="d-flex justify-content-center align-items-center flex-column gap-2 py-5">
                  <img className="mb-3" src={notfound} alt=""/>
                  <p className='mb-0 text-primary'>No se encuentran resultados de tu búsqueda.</p>
                </div>
              </td></tr>
              }
              
            </tbody>
        </table>

      </div>
      {
				page.length > 0 &&
				<PaginationComponent
					pagesCountServer={pageCount}
					currentPage={pageIndex}
					setCurrentPage={gotoPage}
					alwaysShown={true}
					setPagination={setPagination}
				/>
			}
    </div>
  );
};

export default InformadosTable;
